module.exports = __webpack_public_path__ + "7de00359bf54f65e23b8ec47b944ac08.pdf";